module.exports = __webpack_public_path__ + "dash_20_app_assets/img/avatar-s-24.e9860ff6.jpg";